<template>
    <div>
        <v-navigation-drawer
            app
            v-model="drawer"
            disable-resize-watcher
        >
            <v-list v-if="!isAuthenticated">
                <v-list-item to="/">
                    <v-list-item-content>WCCM Calendar</v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item to="/help">
                    <v-list-item-content>Help</v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item to="/sign-up">
                    <v-list-item-content>Sign Up</v-list-item-content>
                </v-list-item>                
                <v-divider></v-divider>
                <v-list-item to="/login">
                    <v-list-item-content>Login</v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>                    
            </v-list>
            <v-list v-else>
                <v-list-item to="/">
                    <v-list-item-content>WCCM Calendar</v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item to="/help">
                    <v-list-item-content>Help</v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout">
                    <v-list-item-content>Hi {{ $store.state.user.user.displayName }}</v-list-item-content>
                    <v-list-item-action>
                        <v-btn icon>
                            <v-icon>mdi-logout</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>                    
            </v-list>
            
        </v-navigation-drawer>
        <v-app-bar color="#6c7c69"
            app
        >
            <v-app-bar-nav-icon
                class="hidden-md-and-up"
                @click="drawer = !drawer"
            ></v-app-bar-nav-icon>
            <v-spacer class="hidden-md-and-up"></v-spacer>

            <v-btn
                text
                to="/"
                class="font-weight-bold title appTitle"
                active-class="appTitle-active"
            >
                WCCM Calendar
            </v-btn>

            <v-spacer class="hidden-sm-and-down"></v-spacer>
           
            <v-btn
                text
                to="/help"
                class="hidden-sm-and-down nav-menu"
            >
                Help
            </v-btn>
            
            <div v-if="!isAuthenticated" class="hidden-sm-and-down">
                <v-btn
                    text
                    to="/sign-up"
                >
                    Sign Up
                </v-btn>
                <v-btn 
                    text
                    to="/login"
                >
                    Login
                </v-btn>
            </div>
            <div v-else>
                <v-btn 
                    class="hidden-sm-and-down"
                    text
                    @click="logout"
                >
                    Hi {{ $store.state.user.user.displayName }}
                    <v-icon right>mdi-logout</v-icon>
                </v-btn>
            </div>
        </v-app-bar>
    </div>
</template>


<style lang="scss">
.v-navigation-drawer .v-list-item--active {
    color: #fff;
}
a.appTitle {
    text-decoration: none;
    text-transform: uppercase;
    color: #fff;
    &-active:before {
       display: none
    }
}
</style>

<script>
export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false       
        };
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('userLogOut');
        }
    }
};
</script>